import { getHeadlessDelivery } from './GetHeadlessDeliveryService';
import { findHeadlessDelivery } from './FindHeadlessDeliveryService';

export default { getHeadlessDelivery, findHeadlessDelivery };
